(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-content-popup-advanced"] && !Shopify.designMode) return;
  try {
    
class PxuContentPopupAdvanced extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.mountController = null;
    this.data = this.#loadData();
    this.$template = this.querySelector('template[data-pxu-content-popup-advanced-template]');
    this.storageKey = `pxu-content-popup-advanced-dismissed-${this.id}`;
    this.triggerTimer = null;
    this.unmountTimer = null;
    this.$dialog = null;
    this.$close = null;
    this.$backdrop = null;
    this.$mountedWrapper = null;

    if (!this.$template) return;

    this.#initGlobalListeners();
    this.#initTrigger();
  }

  disconnectedCallback() {
    this.controller.abort();
    clearTimeout(this.triggerTimer);
    clearTimeout(this.unmountTimer);
    this.unmountTimer = null;
    this.#unmount();
  }

  #initGlobalListeners() {
    const { signal } = this.controller;

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.$dialog?.open) this.#close();
    }, { signal });

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.id) this.#open();
      }, { signal });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.id) this.#close();
      }, { signal });
    }
  }

  #mount() {
    if (this.unmountTimer) {
      clearTimeout(this.unmountTimer);
      this.unmountTimer = null;
    }
    if (this.$dialog) return;

    this.$mountedWrapper = document.createElement('div');
    this.$mountedWrapper.className = this.className;
    const styleAttr = this.getAttribute('style') || '';
    this.$mountedWrapper.setAttribute(
      'style',
      `${styleAttr};position:fixed;inset:0;z-index:2147483647;pointer-events:none;`,
    );
    this.$mountedWrapper.appendChild(this.$template.content.cloneNode(true));

    this.$dialog = this.$mountedWrapper.querySelector('[data-pxu-content-popup-advanced-dialog]');
    this.$close = this.$mountedWrapper.querySelector('[data-pxu-content-popup-advanced-close]');
    this.$backdrop = this.$mountedWrapper.querySelector('[data-pxu-content-popup-advanced-backdrop]');

    document.body.appendChild(this.$mountedWrapper);

    this.mountController = new AbortController();
    const { signal } = this.mountController;

    if (this.$close) {
      this.$close.addEventListener('click', () => this.#close(), { signal });
    }

    if (this.$backdrop) {
      this.$backdrop.addEventListener('click', () => this.#close(), { signal });
    }
  }

  #unmount() {
    this.mountController?.abort();
    this.mountController = null;
    this.$mountedWrapper?.remove();
    this.$mountedWrapper = null;
    this.$dialog = null;
    this.$close = null;
    this.$backdrop = null;
  }

  #initTrigger() {
    const settings = this.data.settings || {};
    const { signal } = this.controller;

    if (Shopify.designMode) {
      this.#open();
      return;
    }

    // Respect show_once setting.
    if (settings.showOnce && this.#hasBeenDismissed()) return;

    const triggerType = settings.triggerType || 'time_delay';

    if (triggerType === 'time_delay') {
      const delay = (settings.timeDelay || 0) * 1000;
      this.triggerTimer = setTimeout(() => this.#open(), delay);

    } else if (triggerType === 'scroll_percentage') {
      const threshold = settings.scrollPercentage || 50;
      const onScroll = () => {
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrolled = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 100;
        if (scrolled >= threshold) {
          this.#open();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true, signal });

    } else if (triggerType === 'exit_intent') {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      // Use `mouseout` instead of `mouseleave` for Safari compatibility —
      // WebKit doesn't reliably fire `mouseleave` on `document`. `mouseout`
      // bubbles and fires consistently across browsers. We treat any exit
      // out of the document (relatedTarget === null) as exit intent.
      const onMouseOut = (event) => {
        if (event.relatedTarget) return;
        this.#open();
        document.removeEventListener('mouseout', onMouseOut);
      };
      document.addEventListener('mouseout', onMouseOut, { signal });
    }
  }

  #open() {
    this.#mount();
    if (this.$dialog.open) return;
    this.$dialog.show();
    // Force a reflow so the browser paints the hidden resting state
    // (opacity 0 + the variant's entrance transform) before we flip to the
    // visible state. Without this the dialog goes from display:none straight
    // to visible in a single frame and the entrance transition never fires.
    void this.$dialog.offsetHeight;
    this.$dialog.classList.add('pxu-content-popup-advanced__dialog--visible');
    this.$backdrop?.classList.add('pxu-content-popup-advanced__backdrop--open');

    // Record the view as soon as the popup is shown so "show once per visitor"
    // holds regardless of how the visitor leaves (close, navigate, reload).
    if (!Shopify.designMode && this.data.settings?.showOnce) this.#markDismissed();
  }

  #close() {
    if (!this.$dialog?.open) return;
    // Drop the visible class to play the exit transition, then close and
    // unmount once it finishes (keeping the dialog [open] meanwhile so it
    // stays rendered through the animation).
    this.$dialog.classList.remove('pxu-content-popup-advanced__dialog--visible');
    this.$backdrop?.classList.remove('pxu-content-popup-advanced__backdrop--open');
    clearTimeout(this.unmountTimer);
    this.unmountTimer = setTimeout(() => {
      this.unmountTimer = null;
      this.$dialog?.close();
      this.#unmount();
    }, 300);
  }

  #hasBeenDismissed() {
    try {
      return localStorage.getItem(this.storageKey) === '1';
    } catch {
      return false;
    }
  }

  #markDismissed() {
    try {
      localStorage.setItem(this.storageKey, '1');
    } catch {
      // Storage unavailable — fail silently
    }
  }

  #loadData() {
    const $dataEl = this.querySelector('[data-component-data]');
    return $dataEl ? JSON.parse($dataEl.textContent) : {};
  }
}

if (!customElements.get('pxu-content-popup-advanced')) {
  customElements.define('pxu-content-popup-advanced', PxuContentPopupAdvanced);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-faq-with-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class FaqWithImageSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.$answers = this.queryAll('[data-pxu-faq-answer]');

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateItemHeights();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.events.register(window, 'resize', debounce(
      () => this.updateItemHeights(), 200)
    );
  }

  updateItemHeights() {
    this.$answers.forEach(($answer) => {
      const openHeight = $answer.scrollHeight;
      $answer.style.setProperty('--open-height', `${openHeight}px`);
    });
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = true;
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const $block = document.getElementById(blockId);
    const $itemTerm = $block.querySelector('[data-pxu-faq-item-term]');
    if (!$itemTerm) return;
    $itemTerm.open = false;
  }
}

document.querySelectorAll(`[data-pxu-faq-with-image]`).forEach(($section) => {
  Section.init($section, FaqWithImageSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.FaqWithImageSection = FaqWithImageSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-menu-list"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class MenuListSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.menus = this.$root.querySelectorAll('[data-pxu-menu-list-block]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this.initEventListeners();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.menus.forEach(el => {
      // Desktop accordian handling
      const trigger = el.querySelector('[data-pxu-menu-list-toggle]');
      if (trigger) {
        const overflowList = el.querySelector('[data-pxu-menu-list-overflow]');
        this.events.register(trigger, 'click', e => this.handleToggle(overflowList));
        this.events.register(overflowList, 'transitionend', e => {
          e.currentTarget.toggleAttribute('data-animating', false);
        });
      }

      // Mobile accordion handling
      const mobileTriggers = el.querySelectorAll('[data-pxu-menu-list-toggle-mobile]');
      const list = el.querySelector('[data-pxu-menu-list-content]');
      if (list.querySelector('li')) {
        mobileTriggers.forEach(mobileTrigger => {
          this.events.register(mobileTrigger, 'click', e => this.handleMobileToggle(e.currentTarget, list));
        });

        this.events.register(list, 'transitionend', e => {
          e.currentTarget.toggleAttribute('data-animating', false);
        });
      }
    });
  }

  handleToggle(overflowList) {
    let animateTo = 'data-hidden';
    let animateFrom = 'data-shown';

    overflowList.setAttribute('data-animating', true);

    if (overflowList.hasAttribute('data-hidden')) {
      animateTo = 'data-shown';
      animateFrom = 'data-hidden';

      let height = overflowList.scrollHeight;
      overflowList.style.setProperty('--pxu-hidden-menu-list-height', `${height}px`);
    }

    overflowList.toggleAttribute(animateTo, true);
    overflowList.toggleAttribute(animateFrom, false);
  }

  handleMobileToggle(target, list) {
    this.handleToggle(list);
    const menu = target.closest('[data-pxu-menu-list-menu-wrapper]');
    menu.querySelector('.pxu-menu-list__icon').toggleAttribute('data-closed');
    menu.querySelector('.pxu-menu-list__icon').toggleAttribute('data-open');
  }
}

document.querySelectorAll('[data-pxu-menu-list]').forEach(($section) => {
  Section.init($section, MenuListSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.MenuListSection = MenuListSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-mosaic"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class MosaicSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-mosaic]').forEach(($section) => {
  Section.init($section, MosaicSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.MosaicSection = MosaicSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
class PxuNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.mountController = null;
    this.data = this.#loadData();
    this.$template = this.querySelector('template[data-pxu-newsletter-popup-template]');
    this.storageKey = `pxu-newsletter-popup-dismissed-${this.id}`;
    this.triggerTimer = null;
    this.successDismissTimer = null;
    this.unmountTimer = null;
    this.$dialog = null;
    this.$close = null;
    this.$backdrop = null;
    this.$mountedWrapper = null;

    if (!this.$template) return;

    // The template content lives in a document fragment, not the live DOM,
    // so password managers can't scan its inputs. We query it here only to
    // detect the just-submitted state.
    this.hasSuccessMessage = !!this.$template.content.querySelector('[data-pxu-newsletter-popup-success]');

    this.#initGlobalListeners();
    this.#initTrigger();
  }

  disconnectedCallback() {
    this.controller.abort();
    clearTimeout(this.triggerTimer);
    clearTimeout(this.successDismissTimer);
    clearTimeout(this.unmountTimer);
    this.unmountTimer = null;
    this.#unmount();
  }

  #initGlobalListeners() {
    const { signal } = this.controller;

    // Manual Escape handler — non-modal dialogs don't get Escape-to-close
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.$dialog?.open) this.#close();
    }, { signal });

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.id) this.#open();
      }, { signal });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.id) this.#close();
      }, { signal });
    }
  }

  #mount() {
    // If a previous close is still mid-transition, cancel the unmount and
    // reuse the already-rendered dialog. This makes a quick re-open during
    // the fade-out animation feel snappy instead of tearing down and
    // rebuilding the popup.
    if (this.unmountTimer) {
      clearTimeout(this.unmountTimer);
      this.unmountTimer = null;
    }
    if (this.$dialog) return;

    // Mount on document.body inside a wrapper that mirrors this element's
    // classes and inline styles. Appending to body escapes any ancestor
    // stacking context that would otherwise trap the popup behind other
    // section content. The mirrored classes (.pxu-section, .pxu-newsletter-popup)
    // keep global section + BEM styles working, and the inline style attribute
    // carries the CSS custom properties used for theming.
    this.$mountedWrapper = document.createElement('div');
    this.$mountedWrapper.className = this.className;
    // Promote the wrapper itself to a high-z-index stacking context at body
    // level. Some themes style .pxu-section with position+z-index, which
    // would otherwise trap the dialog's z-index inside a low stacking
    // context. pointer-events: none lets clicks pass through the empty
    // viewport-sized wrapper to the page underneath.
    const styleAttr = this.getAttribute('style') || '';
    this.$mountedWrapper.setAttribute(
      'style',
      `${styleAttr};position:fixed;inset:0;z-index:2147483647;pointer-events:none;`,
    );
    this.$mountedWrapper.appendChild(this.$template.content.cloneNode(true));

    this.$dialog = this.$mountedWrapper.querySelector('[data-pxu-newsletter-popup-dialog]');
    this.$close = this.$mountedWrapper.querySelector('[data-pxu-newsletter-popup-close]');
    this.$backdrop = this.$mountedWrapper.querySelector('[data-pxu-newsletter-popup-backdrop]');

    document.body.appendChild(this.$mountedWrapper);

    // Per-mount controller so listeners on the cloned nodes are released
    // when #unmount() tears them down. The top-level `this.controller`
    // continues to cover the persistent document/window listeners and
    // disconnectedCallback cleanup.
    this.mountController = new AbortController();
    const { signal } = this.mountController;
    const settings = this.data.settings || {};

    if (!Shopify.designMode) {
      this.$dialog.addEventListener('close', () => {
        if (settings.showOnce) this.#markDismissed();
      }, { signal });
    }

    if (this.$close) {
      this.$close.addEventListener('click', () => this.#close(), { signal });
    }

    if (this.$backdrop) {
      this.$backdrop.addEventListener('click', () => this.#close(), { signal });
    }
  }

  #unmount() {
    this.mountController?.abort();
    this.mountController = null;
    this.$mountedWrapper?.remove();
    this.$mountedWrapper = null;
    this.$dialog = null;
    this.$close = null;
    this.$backdrop = null;
  }

  #initTrigger() {
    const settings = this.data.settings || {};
    const { signal } = this.controller;

    // Shopify redirects back with ?customer_posted=true and the form's id as
    // a hash after a successful submission. The query param keeps
    // form.posted_successfully? true on every subsequent render (refresh,
    // section re-fetch, theme editor re-add). Strip both so the next render
    // returns the form again.
    //
    // Storefront: history.replaceState is instant and unobtrusive.
    // Theme editor: the editor caches the iframe's load URL and uses that
    // for its section re-fetches, so replaceState is invisible to it. A
    // real navigation via location.replace is the only way to force the
    // editor to pick up the clean URL; trade-off is a one-time iframe
    // reload, which is acceptable because this only fires when
    // ?customer_posted=true is actually present.
    if (this.hasSuccessMessage) {
      const url = new URL(window.location.href);
      const hasPostedParam = url.searchParams.has('customer_posted');
      const hasFormHash = url.hash.startsWith('#pxu-newsletter-popup__form-');
      if (hasPostedParam || hasFormHash) {
        url.searchParams.delete('customer_posted');
        if (hasFormHash) url.hash = '';
        if (Shopify.designMode) {
          window.location.replace(url);
          return;
        }
        window.history.replaceState({}, '', url);
      }
    }

    // In the theme editor, open immediately so merchants can preview
    if (Shopify.designMode) {
      this.#open();
      return;
    }

    // If the form was just submitted successfully, re-open to show success message
    // then auto-dismiss after 3s
    if (this.hasSuccessMessage) {
      this.#open();
      this.successDismissTimer = setTimeout(() => this.#close(), 3000);
      return;
    }

    // Respect show_once — skip if already dismissed
    if (settings.showOnce && this.#hasBeenDismissed()) return;

    const method = settings.triggerMethod || 'time_delay';

    if (method === 'time_delay') {
      const delay = (settings.delay || 0) * 1000;
      this.triggerTimer = setTimeout(() => this.#open(), delay);

    } else if (method === 'scroll_percentage') {
      const threshold = settings.scrollPercentage || 50;
      const onScroll = () => {
        const docHeight = document.body.scrollHeight - window.innerHeight;
        const scrolled = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 100;
        if (scrolled >= threshold) {
          this.#open();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true, signal });

    } else if (method === 'exit_intent') {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      // Use `mouseout` instead of `mouseleave` for Safari compatibility —
      // WebKit doesn't reliably fire `mouseleave` on `document`. `mouseout`
      // bubbles and fires consistently across browsers. We treat any exit
      // out of the document (relatedTarget === null) as exit intent.
      const onMouseOut = (event) => {
        if (event.relatedTarget) return;
        this.#open();
        document.removeEventListener('mouseout', onMouseOut);
      };
      document.addEventListener('mouseout', onMouseOut, { signal });
    }
  }

  #open() {
    this.#mount();
    if (this.$dialog.open) return;
    // Use show() (non-modal) instead of showModal() so the dialog isn't
    // placed in the browser's top layer. This lets browser-injected UI
    // like password manager dropdowns appear above the popup.
    this.$dialog.show();
    this.$backdrop?.classList.add('pxu-newsletter-popup__backdrop--open');
  }

  #close() {
    if (!this.$dialog?.open) return;
    this.$dialog.close();
    this.$backdrop?.classList.remove('pxu-newsletter-popup__backdrop--open');
    // Defer the DOM teardown until the opacity/transform transitions
    // finish, otherwise the popup would vanish instantly. Removing the
    // cloned content (rather than just hiding it) is what keeps the form
    // inputs out of reach of password managers between opens.
    // Matches --pxu-transition-duration-300 in base.css.
    clearTimeout(this.unmountTimer);
    this.unmountTimer = setTimeout(() => {
      this.unmountTimer = null;
      this.#unmount();
    }, 300);
  }

  #hasBeenDismissed() {
    try {
      return localStorage.getItem(this.storageKey) === '1';
    } catch {
      return false;
    }
  }

  #markDismissed() {
    try {
      localStorage.setItem(this.storageKey, '1');
    } catch {
      // localStorage unavailable — fail silently
    }
  }

  #loadData() {
    const $dataEl = this.querySelector('[data-component-data]');
    return $dataEl ? JSON.parse($dataEl.textContent) : {};
  }
}

if (!customElements.get('pxu-newsletter-popup')) {
  customElements.define('pxu-newsletter-popup', PxuNewsletterPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-particle-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

function webgl_support() {
  try {
    var canvas = document.createElement('canvas');
    return !!window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
  } catch (e) {
    return false;
  }
};

class ParticleBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.container = this.$root.querySelector('[data-pxu-chladni]');

    if (webgl_support() && !Shopify.visualPreviewMode) {
      this.onMount()
    } else {
      this.$root.classList.add('pxu-particle-banner--unsupported');
    }
  }

  onMount() {
    const params = {
      clearColor: this.data.clearColor,
      textDesktop: this.data.textDesktop,
      textMobile: this.data.textMobile,
      textWidthDesktop: parseInt(this.data.textWidthDesktop, 10) / 100,
      textWidthMobile: parseInt(this.data.textWidthMobile, 10) / 100,
      color: this.data.color,
      fontFamily: this.data.fontFamily,
      aspectRatioMobile: this.data.aspectRatioMobile,
      aspectRatioDesktop: this.data.aspectRatioDesktop,
      duration: this.data.duration,
      lineHeight: parseFloat(this.data.lineHeight)
    };

    const loadChladni = () => {
      this.checkInterval = setInterval(() => {
        if (typeof window.PxuThemeSections?.Chladni === 'function') {
          clearInterval(this.checkInterval);
          this.chladni = new window.PxuThemeSections.Chladni(this.container, params, () => {
            const { bottomRight } = this.chladni.getTextBoxPercentCoordinates();
            this.$root.style.setProperty(
              '--pxu-section-height-under-text',
              `${100 - bottomRight.y}%`
            );
          });
        }
      }, 500);
    };

    loadChladni();
  }

  onUnmount() {
    clearInterval(this.checkInterval);
    this.events.unregisterAll();
    if (this.chladni) this.chladni.onUnmount();
  }
}

document.querySelectorAll('[data-pxu-particle-banner]').forEach(($section) => {
  Section.init($section, ParticleBannerSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ParticleBannerSection = ParticleBannerSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-images"] && !Shopify.designMode) return;
  try {
    
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ScrollingImages extends HTMLElement {
  constructor() {
    super();
    this.paused = false;
  }

  // Section lifecycle

  connectedCallback() {
    this.scrollingImageContent = this.querySelectorAll('[data-scrolling-image-content]'); // wrapper containing images
    if (!this.scrollingImageContent.length) return;
    this.pauseOnHover = this.getAttribute('pause-on-hover') === 'true';
    this.#initScroll();
    this.#handleResize();
    this.#setupTouchClick();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.unobserve(this);
      this.observer = null;
    };
    if (this.ro) {
      this.ro.unobserve(this);
      this.ro = null;
    };
  }

  #handleResize() {
    if (this.ro) return;

    this.ro = new ResizeObserver(
      debounce(() => {
        this.#initScroll();
      }, 50)
    );

    this.ro.observe(this);
  }

  #initScroll() {
    this.scrollingImageContent.forEach((el) => {
      // Get gap from custom element attributes instead of computed style
      const isDesktop = window.matchMedia('(min-width: 480px)').matches;
      const imageGap = parseInt(
        isDesktop 
          ? this.getAttribute('image-gap-desktop') 
          : this.getAttribute('image-gap-mobile'),
        10
      );
      
      const marqueeItems = el.querySelectorAll(
        '[data-scrolling-image-content-item]:not([data-is-clone])'
      );
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items using data attributes from individual items
      let totalItemWidth = [...marqueeItems].reduce(
        (total, item) => {
          const itemWidth = parseInt(
            isDesktop 
              ? item.dataset.desktopWidth 
              : item.dataset.mobileWidth,
            10
          );
          return total + (itemWidth + imageGap);
        },
        0
      );


      if (totalItemWidth > 0) totalItemWidth -= imageGap;

      // Ensure we have enough content for smooth infinite scroll (minimum 2 sets)
      const numImageGroups = Math.max(2, Math.ceil((width * 1.5) / Math.max(totalItemWidth, 1)));
      
      // Check how many clone groups we currently have
      const existingClones = el.querySelectorAll('[data-is-clone="true"]');
      const currentCloneGroups = existingClones.length / marqueeItems.length;
      
      // Only modify clones if the required number has changed
      if (Math.floor(currentCloneGroups) !== numImageGroups - 1) {
        // Remove existing clones
        existingClones.forEach(clone => clone.remove());
        
        // Clone and append marquee items if we don't have enough to fill the container
        for (let i = 1; i < numImageGroups; i++) {
          marqueeItems.forEach((item) => {
            const clone = item.cloneNode(true);
            clone.setAttribute('data-is-clone', 'true');
            el.appendChild(clone);
          });
        }
      }

      // Adjust animation duration based on the number of cloned groups to maintain consistent speed
      if (numImageGroups > 1) {
        const originalDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration'));
        const adjustedDuration = originalDuration * numImageGroups;
        el.style.setProperty('--duration', `${adjustedDuration}s`);
      }
    });

    if (!this.observer) {
      this.#observeAnimations();
    }
  }

  #observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(([entry]) => {
      const { isIntersecting } = entry;
      this.classList.toggle('scrolling-images--is-animated', isIntersecting);
    });
    this.observer.observe(this);
  }

  #setupTouchClick() {
    if (!window.matchMedia('(pointer: coarse)').matches || !this.pauseOnHover) return;
    
    this.addEventListener('click', (e) => {
      this.paused = !this.paused;
      this.scrollingImageContent.forEach((el) => {
        el.style.animationPlayState = this.paused ? 'paused' : 'running';
      });
    });
  }
}

customElements.define('scrolling-images', ScrollingImages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      if (textItems.length === 0) return;
      
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-slideshow"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class SlideshowSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.autoplay = this.data.autoplay;
    this.autoplayDuration = this.data.autoplayDuration * 1000;
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    const options = {
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      prevNextButtons: true,
      lazyLoad: true
    };

    const mobileOptions = {
      draggable: true,
      autoPlay: this.autoplay ? this.autoplayDuration : false,
      lazyLoad: true
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-slideshow]').forEach(($section) => {
  Section.init($section, SlideshowSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.SlideshowSection = SlideshowSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();
})();
